import * as React from "react";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DOMAIN_TE, domainTheme } from "../../themes/theme";

const useStyles = makeStyles(() => ({
  horizontalLogoHeader: {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "100%",
    minHeight: 85,
    marginRight: 25,
  },
}));

const HorizontalLogoHeader = () => {
  const classes = useStyles();

  return (
    <>
      {domainTheme === DOMAIN_TE && (
        <Grid item className={clsx(classes.horizontalLogoHeader, "horizontalLogoHeader")} />
      )}
    </>
  );
};

export default HorizontalLogoHeader;
